import _toConsumableArray from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};
import _styled from "styled-components";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function ImpressionIllustration(_ref) {
  var children = _ref.children,
      variant = _ref.variant;
  return variant === 'mobileImageOverlay' ? /*#__PURE__*/_jsxs(MobileImageOverlay, {
    children: [children, /*#__PURE__*/_jsxs(_StyledDiv, {
      children: [/*#__PURE__*/_jsx(StickNote, {
        styles: [{
          "position": "absolute",
          "top": "0.75rem",
          "left": "64%",
          "--tw-rotate": "-9deg",
          "transform": "translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))",
          "--tw-bg-opacity": "1",
          "backgroundColor": "rgb(105 62 181 / var(--tw-bg-opacity))",
          "--tw-text-opacity": "1",
          "color": "rgb(255 255 255 / var(--tw-text-opacity))"
        }],
        children: "receptionist"
      }), /*#__PURE__*/_jsx(StickNote, {
        styles: [{
          "position": "absolute",
          "top": "3.25rem",
          "left": "1.063rem",
          "--tw-rotate": "8.5deg",
          "transform": "translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))",
          "borderWidth": "1px",
          "--tw-border-opacity": "1",
          "borderColor": "rgb(208 225 36 / var(--tw-border-opacity))",
          "--tw-bg-opacity": "1",
          "backgroundColor": "rgb(208 225 36 / var(--tw-bg-opacity))",
          "--tw-text-opacity": "1",
          "color": "rgb(28 19 39 / var(--tw-text-opacity))"
        }],
        children: "chef"
      }), /*#__PURE__*/_jsx(StickNote, {
        styles: [{
          "position": "absolute",
          "bottom": "4.438rem",
          "left": "2.813rem",
          "--tw-rotate": "-8.69deg",
          "transform": "translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))",
          "borderWidth": "1px",
          "--tw-border-opacity": "1",
          "borderColor": "rgb(105 62 181 / var(--tw-border-opacity))",
          "--tw-bg-opacity": "1",
          "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity))",
          "--tw-text-opacity": "1",
          "color": "rgb(28 19 39 / var(--tw-text-opacity))"
        }],
        children: "cameriere"
      }), /*#__PURE__*/_jsx(StickNote, {
        styles: [{
          "position": "absolute",
          "bottom": "0.938rem",
          "right": "0.688rem",
          "--tw-rotate": "8.5deg",
          "transform": "translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))",
          "borderWidth": "1px",
          "--tw-border-opacity": "1",
          "borderColor": "rgb(208 225 36 / var(--tw-border-opacity))",
          "--tw-bg-opacity": "1",
          "backgroundColor": "rgb(208 225 36 / var(--tw-bg-opacity))",
          "--tw-text-opacity": "1",
          "color": "rgb(28 19 39 / var(--tw-text-opacity))"
        }],
        children: "manager"
      })]
    })]
  }) : /*#__PURE__*/_jsxs(ImageOverlay, {
    children: [children, /*#__PURE__*/_jsxs(_StyledDiv2, {
      children: [/*#__PURE__*/_jsx(StickNote, {
        styles: [{
          "position": "absolute",
          "top": "6.25rem",
          "left": "17.688rem",
          "--tw-rotate": "-9deg",
          "transform": "translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))",
          "--tw-bg-opacity": "1",
          "backgroundColor": "rgb(105 62 181 / var(--tw-bg-opacity))",
          "--tw-text-opacity": "1",
          "color": "rgb(255 255 255 / var(--tw-text-opacity))"
        }],
        children: "receptionist"
      }), /*#__PURE__*/_jsx(StickNote, {
        styles: [{
          "position": "absolute",
          "top": "13.5rem",
          "left": "-1.375rem",
          "--tw-rotate": "8.5deg",
          "transform": "translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))",
          "borderWidth": "1px",
          "--tw-border-opacity": "1",
          "borderColor": "rgb(208 225 36 / var(--tw-border-opacity))",
          "--tw-bg-opacity": "1",
          "backgroundColor": "rgb(208 225 36 / var(--tw-bg-opacity))",
          "--tw-text-opacity": "1",
          "color": "rgb(28 19 39 / var(--tw-text-opacity))"
        }],
        children: "chef"
      }), /*#__PURE__*/_jsx(StickNote, {
        styles: [{
          "position": "absolute",
          "bottom": "21.125rem",
          "left": "5.375rem",
          "--tw-rotate": "-8.69deg",
          "transform": "translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))",
          "borderWidth": "1px",
          "--tw-border-opacity": "1",
          "borderColor": "rgb(105 62 181 / var(--tw-border-opacity))",
          "--tw-bg-opacity": "1",
          "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity))",
          "--tw-text-opacity": "1",
          "color": "rgb(28 19 39 / var(--tw-text-opacity))"
        }],
        children: "cameriere"
      }), /*#__PURE__*/_jsx(StickNote, {
        styles: [{
          "position": "absolute",
          "bottom": "13.125rem",
          "right": "6.125rem",
          "--tw-rotate": "8.5deg",
          "transform": "translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))",
          "borderWidth": "1px",
          "--tw-border-opacity": "1",
          "borderColor": "rgb(208 225 36 / var(--tw-border-opacity))",
          "--tw-bg-opacity": "1",
          "backgroundColor": "rgb(208 225 36 / var(--tw-bg-opacity))",
          "--tw-text-opacity": "1",
          "color": "rgb(28 19 39 / var(--tw-text-opacity))"
        }],
        children: "manager"
      })]
    })]
  });
}
export default ImpressionIllustration;

var MobileImageOverlay = /*#__PURE__*/_styled.div.withConfig({
  displayName: "impression-illustration__MobileImageOverlay",
  componentId: "sc-1hn443g-0"
})(function () {
  return [{
    "position": "relative",
    "zIndex": "9",
    "display": "flex",
    "height": "100%",
    "width": "100%",
    "backgroundColor": "transparent"
  }];
});

var ImageOverlay = /*#__PURE__*/_styled.div.withConfig({
  displayName: "impression-illustration__ImageOverlay",
  componentId: "sc-1hn443g-1"
})(function () {
  return [{
    "position": "absolute",
    "top": "0px",
    "left": "0px",
    "zIndex": "9",
    "display": "flex",
    "height": "100%",
    "width": "100%",
    "backgroundColor": "transparent"
  }];
});

var StickNote = /*#__PURE__*/_styled.div.withConfig({
  displayName: "impression-illustration__StickNote",
  componentId: "sc-1hn443g-2"
})(function (_ref2) {
  var styles = _ref2.styles;
  return [{
    "borderRadius": "0.625rem",
    "paddingLeft": "0.5rem",
    "paddingRight": "0.5rem",
    "paddingTop": "0.125rem",
    "paddingBottom": "0.125rem",
    "fontSize": "0.875rem",
    "lineHeight": "1.875rem",
    "fontWeight": "500",
    "@media (min-width: 1024px)": {
      "paddingLeft": "1rem",
      "paddingRight": "1rem",
      "paddingTop": "0.25rem",
      "paddingBottom": "0.25rem",
      "fontSize": "1.25rem",
      "lineHeight": "1.75rem"
    }
  }].concat(_toConsumableArray(styles || []));
});

var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  displayName: "impression-illustration___StyledDiv",
  componentId: "sc-1hn443g-3"
})({
  "position": "absolute",
  "top": "0px",
  "left": "0px",
  "display": "flex",
  "height": "100%",
  "width": "100%"
});

var _StyledDiv2 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "impression-illustration___StyledDiv2",
  componentId: "sc-1hn443g-4"
})({
  "position": "relative",
  "top": "0px",
  "left": "0px",
  "display": "flex",
  "height": "100%",
  "width": "100%"
});